import PropTypes from 'prop-types';
import React from 'react';
import { Row } from './Row';
import { Header } from './Header';

export class MatrixQuestion extends React.Component {
  render() {
    const { questionnaireItems } = this.props;
    return (
      <div className="matrix table">
        <Header listAnswers={questionnaireItems[0].questionnaireItem.listAnswers} />
        {questionnaireItems.map(item => (
          <Row questionnaireItem={item.questionnaireItem} key={item.questionnaireItem.questionnaireItemId}
            updateAnswer={this.props.updateAnswer}
            validateQuestionnaire={ this.props.validateQuestionnaire } disabled={this.props.disabled}
            answer={item.answer ? item.answer : null}
          />))
        }
      </div>
    );
  }
}

MatrixQuestion.propTypes = {
  questionnaireItems: PropTypes.array,
  updateAnswer: PropTypes.func,
  validateQuestionnaire: PropTypes.func,
  disabled: PropTypes.bool,
};
